import { useGetApiAdmintoolMarketsQuery } from '#api/tmsApiHooks'
import type { EnhancedMarket } from '#types/EnhancedMarket'

interface UseMarketsResult {
  status: 'loading' | 'loaded' | 'error'
  markets: EnhancedMarket[]
  error?: unknown | undefined
}

export const useMarkets = () => {
  const { data, error, isLoading } = useGetApiAdmintoolMarketsQuery(
    {
      recursive: false,
    },
    {
      // 15 Minutes in seconds
      refetchOnMountOrArgChange: 15 * 60,
    },
  )

  const status = isLoading ? 'loading' : error ? 'error' : 'loaded'
  return {
    status,
    markets: (data?.markets ?? []) as EnhancedMarket[],
    error,
  } satisfies UseMarketsResult
}
